module.exports = __webpack_public_path__ + "img/current-img-1.acd9fae6.png";